import { create } from 'zustand';

type CanvasReportContextState = {
  pipelineName: string | null;
  pipelineDescription: string | null;
  setPipelineIdentity: (identity: {
    pipelineName: string | null;
    pipelineDescription: string | null;
  }) => void;
};

/**
 * Lightweight, teardown-surviving holder of the current pipeline/capsule
 * identity. `pipelineStore` is reset on Design unmount, so its `reset()` copies
 * name/description here just before clearing, and the error reporter reads it
 * afterwards. Kept separate (and dependency-free) so the reporter never has to
 * import the heavy `pipelineStore`.
 */
export const useCanvasReportContextStore = create<CanvasReportContextState>(
  set => ({
    pipelineName: null,
    pipelineDescription: null,
    setPipelineIdentity: identity => set(identity)
  })
);
